
import {Component, Prop, Vue} from 'vue-property-decorator';
import {RouterNameEnum} from "@/router/router.types";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import ServiceCreateFormComponent from "@/UI/components/forms/serviceCreate/ServiceCreateFormComponent.vue";
import {FormModel, message} from "ant-design-vue";
import {ServicesCategoryNomenclatureStore} from "@/store/modules/ServicesCategoryNomenclature";
import {ServiceNomenclatureStore} from "@/store/modules/ServicesNomenclature";
import ServiceNomenclatureForm from "@/form/service/serviceNomenclature";
import {
  IServicesNomenclaturesListItem
} from "@/entity/servicesNomenclature/services.nomenclature.types";

@Component({
  components: {ServiceCreateFormComponent, PageTitle}
})
export default class ServicesUpdate extends Vue {

  form = new ServiceNomenclatureForm();
  formReady = false;
  formErrors: Record<string, any> = {};

  get service(): IServicesNomenclaturesListItem | null {
    return ServiceNomenclatureStore.service;
  }

  async editService(): Promise<void> {
    ((this.$refs.serviceForm as any).$refs.serviceForm as FormModel).validate(async (valid) => {
      const formErrors = Object.keys(this.formErrors);
      if(formErrors.length) {
        for(let i = 0; i < formErrors.length; i++) {
          this.$message.error(this.formErrors[formErrors[i]]);
        }
        valid = false;
      }
      if (valid) {
        if (await this.form.submit(ServiceNomenclatureStore.update)) {
          await ServicesCategoryNomenclatureStore.fetchAll();
          this.form = new ServiceNomenclatureForm();

          await this.$router.push({name: RouterNameEnum.Services, params: {Studio: "0"}});
        }
      }
    })
  }

  setError(property: string, value: string) {
    this.formErrors[property] = value;
  }

  clearError() {
    this.formErrors = {};
  }

  async created(): Promise<void> {
    await ServiceNomenclatureStore.fetchData({filter: {id: parseInt(this.$route.params.id)}});
    this.form.setFormData(this.service);
    this.form.price_second = Number(this.service?.price_second)
    this.formReady = true;
  }
}
